<template>
  <div>
    <div @click="$router.go(-1)" class="arrow_text cursor-pointer">
      <chevron-left-icon
        size="1.5x"
        class="custom-class"
        style="vertical-align: top;"
      ></chevron-left-icon>
      <span class="back">Back</span>
    </div>

    <h1 class="mt-2 mb-3 font-regular">
      Quick Search
    </h1>

    <div class=" row">
      <div
        class="col-12"
        :class="
          action_type === ''
            ? ''
            : action_type === 'account_balance'
            ? 'col-lg-6 col-md-6'
            : 'col-lg-3 col-md-6'
        "
      >
        <div class="form-group">
          <label for="">What Do You Want Here?</label>
          <select
            name=""
            id=""
            class=" form-control"
            v-model="action_type"
            @change="resetValues"
          >
            <option value="" disabled>Pick Your Action</option>
            <option
              value="account_balance"
              v-if="permissions.includes('view-account-balance')"
              >Check Account Balance
            </option>
            <option
              value="account_statement"
              v-if="permissions.includes('statement')"
              >Statement Of Account</option
            >
            <option value="bvn" v-if="permissions.includes('view-bvn')"
              >Check BVN</option
            >
            <option value="nin" v-if="permissions.includes('view-bvn')">Check NIN</option>
            <option value="phone_number" v-if="permissions.includes('view-bvn')">Check Phone Number</option>
            <option value="credit_report" v-if="permissions.includes('credit-report')">Credit Report</option>
          </select>
        </div>
      </div>
      <div
        class="col-12 col-lg-3 col-md-6"
        v-if="action_type === 'account_statement'"
      >
        <div class="form-group">
          <label for="">Start Date</label>
          <input type="date" v-model="start_date" class="form-control" />
        </div>
      </div>
      <div
        class="col-12 col-lg-3 col-md-6"
        v-if="action_type === 'account_statement'"
      >
        <div class="form-group">
          <label for="">Stop Date</label>
          <input type="date" v-model="stop_date" class="form-control" />
        </div>
      </div>
      <div
        class="col-12"
        :class="
          action_type === 'account_balance'
            ? 'col-lg-6 col-md-6'
            : 'col-lg-3 col-md-6'
        "
        v-if="
          action_type === 'account_statement' || action_type === 'credit_report' 
          ||
            action_type === 'account_balance'
        "
      >
        <div class="form-group">
          <label for="">Account Number</label>
          <input
            type="text"
            maxlength="10"
            class=" form-control"
            @keypress="isNumber($event)"
            v-model="account_number"
            placeholder=""
          />
        </div>
      </div>

      <div
        class="col-12 col-lg-3 col-md-6"
        v-if="
          action_type === 'bvn' ||
            action_type === 'nin' ||
            action_type === 'phone_number' ||
            action_type === 'credit_report'
        "
      >
        <div class=" form-group">
          <label for="">Identifier Number</label>
          <input
            type="text"
            class=" form-control"
            v-model="bvn"
            placeholder="1234567890"
          />
        </div>
      </div>
      <div
        class="col-12 col-lg-3 col-md-6"
        v-if="
          action_type === 'bvn' ||
            action_type === 'nin' ||
            action_type === 'phone_number' ||
            action_type === 'credit_report'
        "
      >
        <div class=" form-group">
          <label for="">Pull Fresh</label>
          <select name="" id="" v-model="is_fresh" class=" form-control">
            <option value="no">No</option>
            <option value="yes">Yes</option>
          </select>
        </div>
      </div>
      <div
        class="col-12 col-lg-3 col-md-6"
        v-if="action_type === 'credit_report'"
      >
        <div class=" form-group">
          <label for="">First Name</label>
          <input type="text" class=" form-control" v-model="first_name" />
        </div>
      </div>
      <div
        class="col-12 col-lg-3 col-md-6"
        v-if="action_type === 'credit_report'"
      >
        <div class=" form-group">
          <label for="">Last Name</label>
          <input type="text" class=" form-control" v-model="last_name" />
        </div>
      </div>
      <div
        class="col-12 col-lg-3 col-md-6"
        v-if="action_type === 'credit_report'"
      >
        <div class=" form-group">
          <label for="">DOB</label>
          <input type="date" class=" form-control" v-model="dob" />
        </div>
      </div>
      <div
        class="col-12 col-lg-3 col-md-6"
        v-if="action_type === 'credit_report'"
      >
        <div class=" form-group">
          <label for="">Credit TYPe</label>
          <select name="" id="" v-model="credit_report_type" class=" form-control">
            <option value="sme">SME</option>
            <option value="nano">Nano</option>
          </select>
        </div>
      </div>
      <div class="col-12" v-if="action_type !== ''">
        <button
          @click="performAction"
          class="btn btn-primary w-100"
          :disabled="accountLoading"
        >
          <span v-if="accountLoading">
            <loader-icon></loader-icon>
            <span>Please Wait</span>
          </span>
          <span v-else>Perform Action</span>
        </button>
      </div>
    </div>

    <BankStatement :statement="statement" />
    <div v-if="bvnDetails">
      <div class="card card--no-shadow">
        <div class=" card-header">
          <h3 class="font-wieght-600 mb-0">
            BVN Profile
          </h3>
        </div>
        <div class=" card-content">
          <div class="card-body">
            <ImageMagnifying :img="bvnDetails.captured_image" />
            <ImageMagnifying :img="bvnDetails.image" />
            <KeyValue objKey="First Name" :objValue="bvnDetails.first_name" />
            <KeyValue objKey="Last Name" :objValue="bvnDetails.last_name" />
            <KeyValue
              objKey="Other NAme"
              :objValue="bvnDetails.other_name"
              v-if="bvnDetails.other_name"
            />
            <KeyValue
              objKey="Middle Name"
              :objValue="bvnDetails.middle_name"
              v-if="bvnDetails.middle_name"
            />
            <KeyValue
              objKey="BVN"
              :objValue="bvnDetails.bvn"
              v-if="bvnDetails.bvn"
            />
            <KeyValue
              objKey="Address"
              :objValue="bvnDetails.address"
              v-if="bvnDetails.address"
            />
            <KeyValue
              objKey="DOB"
              :objValue="bvnDetails.dob"
              v-if="bvnDetails.dob"
            />
            <KeyValue
              objKey="Email"
              :objValue="bvnDetails.email"
              v-if="bvnDetails.email"
            />
            <KeyValue
              objKey="Enrollment Bank"
              :objValue="bvnDetails.enrollment_bank"
              v-if="bvnDetails.enrollment_bank"
            />
            <KeyValue
              objKey="Enrollment Branch"
              :objValue="bvnDetails.enrollment_branch"
              v-if="bvnDetails.enrollment_branch"
            />
            <KeyValue
              objKey="Account Level"
              :objValue="bvnDetails.level_of_account"
              v-if="bvnDetails.level_of_account"
            />
            <KeyValue objKey="First Mobile" :objValue="bvnDetails.mobile" />
            <KeyValue objKey="Second Mobile" :objValue="bvnDetails.mobile_2" />
            <KeyValue
              objKey="NIN"
              :objValue="bvnDetails.nin"
              v-if="bvnDetails.nin"
            />
            <KeyValue
              objKey="State Of Origin"
              :objValue="bvnDetails.state_of_origin"
            />
            <KeyValue
              objKey="State Of Residence"
              :objValue="bvnDetails.state_of_residence"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="credit_report">
      <div class="col-md-12">
        <h3>
          {{ credit_report.header }}
        </h3>
      </div>
      <div class="col-md-4">
        <div class="card card--no-shadow card-profile">
          <div class="card-header">
            <h3 class="font-weight-600 mb-0">Scoring</h3>
          </div>
          <div class="card-content">
            <div class="card-body">
              <KeyValue
                objKey="Score Risk"
                :objValue="credit_report.score_description"
              />
              <KeyValue
                objKey="Repayment History Score"
                :objValue="credit_report.repayment_history_score"
              />
              <KeyValue
                objKey="Total Amount Owned Score"
                :objValue="credit_report.total_amount_owned_score"
              />
              <KeyValue
                objKey="Type of Credit Score"
                :objValue="credit_report.types_of_credit_score"
              />
              <KeyValue
                objKey="Length of Credit History Score"
                :objValue="credit_report.length_of_credit_history_score"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card card--no-shadow card-profile">
          <div class="card-header">
            <h3 class="font-weight-600 mb-0">Account</h3>
          </div>
          <div class="card-content">
            <div class="card-body" v-if="credit_report.credit_account_summary">
              <div
                class="transaction-details"
                v-for="(value,
                name,
                index) in credit_report.credit_account_summary"
                :key="index"
              >
                <KeyValue
                  :objKey="name"
                  :objValue="value"
                  v-if="value != '0'"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <CDataTable
          :items="credit_report.credit_agreement_summary"
          :fields="creditAgreementSummaryFields"
          pagination
        >
        </CDataTable>
      </div>
    </div>
  </div>
</template>

<script>
import BankStatement from "@/components/BankStatement";
import Swal from "sweetalert2";
import ApiService from "@/services/api.service";
import CDataTable from "@/components/CDataTable";
import CPagination from "@/components/CPagination";
import CModal from "@/components/CModal";

import ErrorService from "@/services/error.service";
import KeyValue from "@/components/KeyValue.vue";
import ImageMagnifying from "../components/ImageMagnifying.vue";
const sFields = [
  "bookingDate",
  "closingBalance",
  "creditAmount",
  "debitAmount",
  "valueDate",
  "tnxRef",
  "action"
];

const creditAgreementSummaryFields = [
  "DateAccountOpened",
  "ClosedDate",
  "SubscriberName",
  "IndicatorDescription",
  "OpeningBalanceAmt",
  "CurrentBalanceAmt",
  "AmountOverdue",
  "AccountStatus",
  "PerformanceStatus"
];

export default {
  name: "Utility",
  components: {
    BankStatement,
    KeyValue,
    ImageMagnifying,
    CDataTable
    // CCard
  },
  data() {
    return {
      sFields,
      statement: null,
      bvn: "",
      action_type: "bvn",
      account_number: "",
      start_date: "",
      stop_date: "",
      accountLoading: false,
      singleStatement: null,
      showStDetails: false,
      bvnDetails: null,
      first_name: "",
      last_name: "",
      dob: "",
      credit_report: null,
      is_fresh: "no",
      credit_report_type : "sme",
    };
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    },
    formIsValid() {
      if (this.action_type === "") {
        return false;
      } else {
        if (
          this.action_type === "bvn" ||
          this.action_type === "nin" ||
          this.action_type === "phone_number"
        ) {
          return this.bvn.length > 10;
        }
        if (this.action_type === "account_balance") {
          return this.account_number.length === 10;
        }
        if (this.action_type === "account_statement") {
          return (
            this.start_date !== "" &&
            this.stop_date !== "" &&
            this.account_number.length === 10
          );
        }
      }
    }
  },
  methods: {
    resetValues() {
      this.statement = null;
      this.bvnDetails = null;
    },

    isNumber: function(evt) {
      console.log(evt.key);
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    performAction() {
      if (this.action_type === "account_balance") {
        this.revealBalance();
      }
      if (this.action_type === "account_statement") {
        if (this.start_date > this.stop_date) {
          Swal.fire({
            title: "Error",
            icon: "error",
            timer: 3000,
            text: "The Stop Date is Behind the Start Date"
          });
        } else {
          this.getStatement();
        }
      }

      if (this.action_type === "bvn") {
        this.viewBVN();
      }

      if (this.action_type === "nin") {
        this.viewNIN();
      }
      if (this.action_type === "phone_number") {
        this.viewPhone();
      }
      if (this.action_type === "credit_report") {
        this.viewCreditReport();
      }
    },
    async viewPhone() {
      this.accountLoading = true;
      try {
        const res = await ApiService.post("verification/verify_phone", {
          phone_number: this.bvn,
          is_fresh: this.is_fresh
        });
        // console.log(res);
        console.log(res.data.data.image);
        this.bvnDetails = res.data.data;
        this.accountLoading = false;
      } catch (error) {
        this.accountLoading = false;
        ErrorService.displayErrorAlert(error.response.data);
      }
    },
    async viewNIN() {
      this.accountLoading = true;
      try {
        const res = await ApiService.post("verification/verify_nin", {
          nin: this.bvn,
          is_fresh: this.is_fresh
        });
        // console.log(res);
        // console.log(res.data.data.image);
        this.bvnDetails = res.data.data;
        this.accountLoading = false;
      } catch (error) {
        this.accountLoading = false;
        ErrorService.displayErrorAlert(error.response.data);
      }
    },
    async viewBVN() {
      this.accountLoading = true;
      try {
        const res = await ApiService.post("bvn/view", {
          bvn: this.bvn,
          is_fresh: this.is_fresh
        });
        // console.log(res.data.data.image);
        this.bvnDetails = res.data.data;
        this.accountLoading = false;
      } catch (error) {
        this.accountLoading = false;
        ErrorService.displayErrorAlert(error.response.data);
      }
    },
    async getStatement() {
      this.accountLoading = true;
      try {
        let response = await ApiService.post("payment/request-statement", {
          start_date: this.start_date,
          end_date: this.stop_date,
          account_number: this.account_number
        });
        var _url = response.data.data;

        //download the file
        var a = document.createElement("a");
        a.href = _url;
        a.download = "statement.pdf";
        document.body.appendChild(a);
        a.click();

        this.accountLoading = false;
      } catch (error) {
        console.log(error.response);
        this.accountLoading = false;
        ErrorService.displayErrorAlert(error.response.data);
      }
    },
    async revealBalance() {
      this.accountLoading = true;
      try {
        let response = await ApiService.post(`account/balance`, {
          account_number: this.account_number
        });
        this.accountLoading = false;
        Swal.fire({
          title: "Account Balance",
          text: `₦${response.data.data.available_balance}`,
          icon: "success",
          confirmButtonText: "Ok"
        });
      } catch (error) {
        this.accountLoading = false;
        ErrorService.displayErrorAlert(error.response.data);
      }
    },
    async viewCreditReport() {
      this.accountLoading = true;
      try {
        let response = await ApiService.post(`bvn/get-credit-report`, {
          first_name: this.first_name,
          last_name: this.last_name,
          dob: this.dob,
          bvn: this.bvn,
          debit_account : this.account_number,
          credit_report_type : this.credit_report_type
        });
        this.accountLoading = false;
        console.log(response.data.data);
        this.credit_report = response.data.data;
        Swal.fire({
          title: "Credit Report",
          // text: `Credit Score: ${response.data.mesage}`,
          icon: "success",
          confirmButtonText: "Ok"
        });
      } catch (error) {
        this.accountLoading = false;
        ErrorService.displayErrorAlert(error.response.data);
      }
    }
  }
};
</script>

<style scoped></style>
